/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Resetemailsuccess2Inputs */

const zh_auth_resetemailsuccess2 = /** @type {(inputs: Auth_Resetemailsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置邮件已发送`)
};

const en_auth_resetemailsuccess2 = /** @type {(inputs: Auth_Resetemailsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset email sent successfully`)
};

const es_auth_resetemailsuccess2 = /** @type {(inputs: Auth_Resetemailsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo de restablecimiento enviado`)
};

/**
* | output |
* | --- |
* | "Reset email sent successfully" |
*
* @param {Auth_Resetemailsuccess2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_resetemailsuccess2 = /** @type {((inputs?: Auth_Resetemailsuccess2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Resetemailsuccess2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_resetemailsuccess2(inputs)
	if (locale === "en") return en_auth_resetemailsuccess2(inputs)
	return es_auth_resetemailsuccess2(inputs)
});
export { auth_resetemailsuccess2 as "auth_resetEmailSuccess" }